/* eslint-disable */
import {
  CapThongKeGetAll,
  DonViThongKeGetByCode,
} from "@/services/api/HoSoCanBoCongChuc/DanhMuc/DonViThongKeService";

import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import { useRouter } from "@core/utils/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function useDonViService() {
  const toast = useToast();
  const { route, router } = useRouter();
  const donViGetInfo = (ctx, callback) => {
    if (ctx == undefined || ctx == null) {
      CapThongKeGetAll().then((response) => {
        // console.log("ctx", response);
        if (!response.isError) {
          callback(response.data);
        } else {
          router.replace("/admin/donvi/dashboard").then(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: "Error: Go To Common Dashboard",
                icon: "AlertTriangleIcon",
                variant: "danger",
                text: response.message,
              },
            });
          });
        }
      });
    } else {
      DonViThongKeGetByCode(ctx).then((response) => {
        // console.log("ctx", response);
        if (!response.isError) {
          callback(response.data);
        } else {
          router.replace("/admin/donvi/dashboard").then(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: "Error: Go To Common Dashboard",
                icon: "AlertTriangleIcon",
                variant: "danger",
                text: response.message,
              },
            });
          });
        }
      });
    }
  };
  return {
    donViGetInfo,
  };
}
